


const SelectBox = (props: any) => {

  let label = props.label ?? '';
  let firstSelect = props.firstSelect ?? '';
  let value = props.value ?? '';
  let params = props.params ?? [];
  const paramFormatValue = (value: any) => {
    if (value) {
      return value.replace(" ", "_");
    }
    else {
      return null
    }
  }

  const UpdadeValue = (valueSelect: any) => {
    props.handleChange(valueSelect)
  }

  return (
    <>
      {(params &&
        <div className="SelectBox">
          {((label) ? <label htmlFor="">{label}</label> : <></>)}
          <select value={value} onChange={(e) => UpdadeValue(e.target.value)} className="form-select form-select-sm" aria-label=".form-select-sm example">
            {firstSelect &&
              <option value="">{firstSelect}</option>
            }
            {params.map((param: any, index: any) =>
              <option key={index} value={paramFormatValue(param[1])} >{param[0]}</option>
            )
            }
          </select>
        </div>
      )}
    </>
  )
}

export default SelectBox